import React, { PureComponent } from 'react'
import { Collapse, Table } from 'react-bootstrap'
import { groupBy } from '../../../utils/helpers'
import DataHitListItem from './data_hit_list_item'

class DataListings extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      open: true,
      hits: [],
    }
  }

  componentDidMount() {
    const { props } = this
    const { identityDataSources, data, mediaData, updateComplianceCount } = props
    if (identityDataSources && identityDataSources[0]) {
      const amlHits = identityDataSources[0].aml_hits
      const amlSourceNotes = groupBy(identityDataSources[0].aml_source_notes, 'provider_id')
      const dataListings = groupBy(data || [], 'provider_id')
      const mediaReferences = groupBy(mediaData, 'provider_id')

      let hits = amlHits.map((h) => {
        const notes = amlSourceNotes[h['provider_id']] || []
        const data = dataListings[h['provider_id']] || []
        const media = mediaReferences[h['provider_id']] || []
        return { ...h, ...{ amlSourceNotes: notes, dataListings: data, mediaReferences: media } }
      })

      hits = hits.filter((hit) => {
        const listing = hit.dataListings.map((d) => d.listing_type.name).join(' ')
        return listing.includes('sanction') || listing.includes('warning') || listing.includes('fitness-probity')
      })
      hits = this.getHits(hits)
      updateComplianceCount(hits.filter((h) => !h.checked).length)
      this.setState({ hits })
    }
  }

  confirm = (hit) => (event) => {
    if (event.target.checked) {
      window.localStorage.setItem(`${this.props.id}-sanction-${hit.provider_id}`, 'checked')
      const count = this.props.count - 1
      this.props.updateComplianceCount(count < 0 ? 0 : count)
    } else {
      window.localStorage.removeItem(`${this.props.id}-sanction-${hit.provider_id}`)
      this.props.updateComplianceCount(this.props.count + 1)
    }
  }

  getHits = (origArray) => {
    const { props } = this
    return origArray.reduce((filtered, hit) => {
      const checkboxState = window.localStorage.getItem(`${props.id}-sanction-${hit.provider_id}`)
      filtered.push({
        ...hit,
        checked: checkboxState === 'checked',
      })
      return filtered
    }, [])
  }

  render() {
    const { props, state } = this
    const { data, type } = props

    const { hits } = state
    const chevronClass = state.open ? 'fa fa-chevron-down' : 'fa fa-chevron-right'
    let alertClass = 'label label-info-danger'
    if (data && data.length) {
      alertClass = 'label label-info-data-danger'
    }
    const borderRadius = state.open ? '10px 10px 0 0' : '10px 10px 10px 10px'
    return (
      <div className='ibox float-e-margins animated fadeIn section-shadow'>
        <div
          style={{ borderRadius: borderRadius, cursor: 'pointer' }}
          onClick={() => this.setState({ open: !state.open, viewedNew: true })}
          className='ibox-title'
        >
          <i style={{ width: '10px' }} className={chevronClass} />
          <header>Global Sanctions & Watchlist Matches</header>
          <span style={{ float: 'right' }} className={alertClass}>
            {hits.length}
          </span>
        </div>
        <Collapse in={state.open}>
          <div>
            <div style={{ borderRadius: '0 0 10px 10px' }} className='ibox-content table-responsive'>
              {hits.length ? (
                <Table bordered hover>
                  <thead>
                    <tr>
                      <th>Results by Name</th>
                      <th>Reviewed by Compliance</th>
                    </tr>
                  </thead>
                  <tbody>
                    {hits.map((hit, i) => (
                      <DataHitListItem
                        shareURL={this.props.identityDataSources[0].raw_data.content.data.share_url}
                        key={i}
                        checked={hit.checked}
                        collapseSection={this.collapseSection}
                        confirm={this.confirm(hit)}
                        hit={hit}
                        type={type}
                      />
                    ))}
                  </tbody>
                </Table>
              ) : (
                <span>{'N/A'}</span>
              )}
            </div>
          </div>
        </Collapse>
      </div>
    )
  }
}

export default DataListings
